import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx, css } from "@emotion/core";
import PropTypes from "prop-types";
export function getEmbedStyles(width, height) {
  var percentage = height / width * 100;
  return css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    position: relative;\n    display: block;\n    width: 100%;\n    padding: 0;\n    & > * {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n    ::before {\n      display: block;\n      content: \"\";\n      padding-top: ", "%;\n    }\n  "], ["\n    position: relative;\n    display: block;\n    width: 100%;\n    padding: 0;\n    & > * {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n    ::before {\n      display: block;\n      content: \"\";\n      padding-top: ", "%;\n    }\n  "])), percentage);
}
/**
 * The Embed component maintains the provided aspect ratio determined
 * by the width and height props. It's useful for avoiding content shifting on image
 * loading.
 */

export var Embed = function Embed(_a) {
  var _b = _a.width,
      width = _b === void 0 ? 4 : _b,
      _c = _a.height,
      height = _c === void 0 ? 3 : _c,
      other = tslib_1.__rest(_a, ["width", "height"]);

  return jsx("div", tslib_1.__assign({
    css: getEmbedStyles(width, height)
  }, other));
};
Embed.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};
var templateObject_1;